import React, { Component } from "react";
import { Link } from "react-router-dom";
import OrganizationDropdown from "./organization-dropdown";

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    let nameAbr = "nn";
    if (this.props.user.firstName && this.props.user.lastName) {
      nameAbr = (this.props.user.firstName.charAt(0) + this.props.user.lastName.charAt(0)).toUpperCase();
    }
    var isDarkMode = this.props.theme === "dark";
    var sidebarToggleIcon = this.props.isSidebarCollapsed ? "fa-chevron-double-right" : "fa-chevron-double-left";
    var orgId = this.props.organization.id || 0;
    var orgLink = "/organizations/" + orgId;
    return (
      <nav className="navbar app-navbar navbar-expand-lg navbar-light bg-white sticky-top border-bottom">
        <div className="navbar-nav mr-auto d-flex flex-row align-items-center">
          <button
            className={`btn btn-sm app-sidebar-toggle mr-2 fas ${sidebarToggleIcon}`}
            type="button"
            onClick={this.props.toggleSidebarCollapse}
            aria-label={this.props.isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
            title={this.props.isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
          />
          <OrganizationDropdown user={this.props.user} organization={this.props.organization} organizations={this.props.organizations} handleOrganization={this.props.handleOrganization} />
        </div>
        <div className="col text-right align-items-center">
          <div className="d-flex flex-row-reverse align-items-center">
            <div className="dropleft" id="userDropdown">
              <b className="btn" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {nameAbr}
              </b>
              <div className="dropdown-menu" aria-labelledby="userDropdown">
                <Link className="dropdown-item" to="/profile" type="button" id="profile">
                  <i className="mr-3 far fa-user-circle" />
                  Profile
                </Link>
                <Link className="dropdown-item" to={orgLink} type="button" id="profile">
                  <i className="mr-3 far fa-building" />
                  Organization
                </Link>
                <Link className="dropdown-item" to="/subscriptions" type="button" id="profile">
                  <i className="mr-3 far fa-tag" />
                  Subscriptions
                </Link>
                <Link className="dropdown-item" to="/members" type="button" id="profile">
                  <i className="mr-3 far fa-users" />
                  Members
                </Link>
                <Link className="dropdown-item" to="/connections" type="button" id="profile">
                  <i className="mr-3 far fa-exchange-alt" />
                  Connections
                </Link>
                {/* <Link className="dropdown-item" to="/video-tours" type="button" id="profile">
                  <i className="fa-regular fa-folder" style={{ color: "red" }} />
                  Resources
                </Link> */}
                <button className="dropdown-item" to="/logout" type="button" id="logout" onClick={this.props.logout}>
                  <i className="mr-3 fad fa-sign-out-alt" />
                  Logout
                </button>
              </div>
            </div>
            <Link className="btn far fa-cog" type="button" to="/settings"></Link>
            <button className="btn far fa-bell"></button>
            <button
              className="btn theme-toggle mr-2"
              type="button"
              onClick={this.props.toggleTheme}
              aria-label={`Switch to ${isDarkMode ? "light" : "dark"} mode`}
              aria-pressed={isDarkMode}
              title={`Switch to ${isDarkMode ? "light" : "dark"} mode`}
            >
              <span className="theme-toggle-track">
                <span className="theme-toggle-thumb">
                  <i className={`fas ${isDarkMode ? "fa-moon" : "fa-sun"}`} aria-hidden="true" />
                </span>
              </span>
            </button>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;
